export const validatePhone = (phone: string) => {
  return phone && String(phone).length >= 8 && !isNaN(parseInt(phone));
};
